var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05197 7.75999C5.83398 8.18781 5.83398 8.74786 5.83398 9.86797V14.1346C5.83398 15.2547 5.83398 15.8148 6.05197 16.2426C6.24372 16.6189 6.54968 16.9249 6.926 17.1166C7.35383 17.3346 7.91388 17.3346 9.03398 17.3346H15.9673C17.0874 17.3346 17.6475 17.3346 18.0753 17.1166C18.4516 16.9249 18.7576 16.6189 18.9493 16.2426C19.1673 15.8148 19.1673 15.2547 19.1673 14.1346V9.86797C19.1673 8.74786 19.1673 8.18781 18.9493 7.75999C18.7576 7.38366 18.4516 7.0777 18.0753 6.88596C17.6475 6.66797 17.0874 6.66797 15.9673 6.66797H9.03398C7.91388 6.66797 7.35383 6.66797 6.926 6.88596C6.54968 7.0777 6.24372 7.38366 6.05197 7.75999ZM9.54444 9.45156C9.24083 9.24328 8.82585 9.32056 8.61757 9.62418C8.40929 9.92779 8.48658 10.3428 8.79019 10.551L11.3693 12.3203C12.051 12.788 12.9503 12.788 13.632 12.3203L16.2111 10.551C16.5147 10.3428 16.592 9.92779 16.3837 9.62418C16.1754 9.32056 15.7605 9.24328 15.4569 9.45156L12.8778 11.2208C12.6505 11.3767 12.3508 11.3767 12.1235 11.2208L9.54444 9.45156Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ffc9cfa12c42fc9676d6dbbe5083a7ec.svg";
export { ForwardRef as ReactComponent };